module.exports = __webpack_public_path__ + "static/CookiesChef_part4_81_37-d4514585ddcb8f399981628577832850.mp3";